<script>
import Layout from "../../layouts/main";
import appConfig from "../../../../app.config";

/**
 * Ruta comodín: URL desconocida dentro del shell (riel + barra superior).
 */
export default {
  page: {
    title: "Página no encontrada",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
  },
};
</script>

<template>
  <Layout>
    <section class="text-center py-5" aria-labelledby="nf-title">
      <h1 id="nf-title" class="h3 font-weight-bold mb-3">Esta página no existe</h1>
      <p class="text-secondary mb-4">
        El enlace puede estar incompleto o la página fue movida. Vuelve al inicio para seguir.
      </p>
      <router-link to="/" class="btn btn-primary">Ir al inicio</router-link>
    </section>
  </Layout>
</template>
